import { Component, computed, effect, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { I18nService } from '../core/i18n.service';
import { SeoService } from '../core/seo.service';
import { SiteConfigService } from '../core/site-config.service';
import { BlogHomeWidgetComponent } from '../widgets/blog/blog-home-widget.component';
import { FeedsWidgetComponent } from '../widgets/feeds/feeds-widget.component';
import { FortuneWidgetComponent } from '../widgets/fortune/fortune-widget.component';
import { SellersPage } from './sellers.page';
import { HobyleHomeComponent } from '../widgets/home/brand-showcase/hobyle-home.component';
import { ServiceBrandHomeComponent } from '../widgets/home/brand-showcase/service-brand-home.component';
import { AymudoModernHomeComponent } from '../widgets/aymudo/aymudo-modern-home.component';
import { AuthService } from '../core/auth.service';
import { AppointmentMarketplaceHomeComponent } from '../widgets/appointment-marketplace/appointment-marketplace-home.component';
import { RestaurantMenuHomeComponent } from '../widgets/home/restaurant-menu-home.component';
import { QrMarketplaceHomeComponent } from '../widgets/qr-marketplace/qr-marketplace-home.component';
import { VetMarketplaceHomeComponent } from '../widgets/vet-marketplace/vet-marketplace-home.component';
import { ClinicMarketplaceHomeComponent } from '../widgets/clinic-marketplace/clinic-marketplace-home.component';
import { FortuneCategoryFlowComponent } from '../widgets/fortune-category/fortune-category-flow.component';
import { PageDataService } from '../core/page-data.service';

@Component({
  selector: 'app-home-page',
  imports: [RouterLink, BlogHomeWidgetComponent, FeedsWidgetComponent, FortuneWidgetComponent, FortuneCategoryFlowComponent, SellersPage, HobyleHomeComponent, ServiceBrandHomeComponent, AymudoModernHomeComponent, AppointmentMarketplaceHomeComponent, RestaurantMenuHomeComponent, QrMarketplaceHomeComponent, VetMarketplaceHomeComponent, ClinicMarketplaceHomeComponent],
  template: `
    @if (site.config().brandKey === 'klinik') {
      <app-clinic-marketplace-home />
    } @else if (site.config().businessMode === 'veterinaryMarketplace') {
      <app-vet-marketplace-home />
    } @else if (site.config().businessMode === 'qrMarketplace') {
      <app-qr-marketplace-home />
    } @else if (site.config().brandKey === 'aymudo') {
      <app-aymudo-modern-home />
    } @else if (site.experience('fortune')) {
      <div class="falderyasi-home-stack">
        <section class="home-sellers-heading" aria-labelledby="home-seo-title">
          <h1 id="home-seo-title">{{ i18n.t('homeSeoTitle') }}</h1>
        </section>
        @if (!auth.loggedIn() || auth.user()?.emailVerified === false) {
          <aside class="email-credit-banner" [attr.aria-label]="homeCopy().rewardLabel">
            @if (auth.loggedIn()) {
              <div><span class="eyebrow">{{ homeCopy().verifiedEyebrow }}</span><h2>{{ homeCopy().verifyTitle }}</h2><p>{{ homeCopy().verifyLead }}</p></div>
              <a [routerLink]="i18n.routePath('profile')">{{ homeCopy().verifyAction }} <b>→</b></a>
            } @else {
              <div><span class="eyebrow">{{ homeCopy().registerEyebrow }}</span><h2>{{ homeCopy().registerTitle }}</h2><p>{{ homeCopy().registerLead }}</p></div>
              <button type="button" (click)="openRegister()">{{ homeCopy().registerAction }} <b>→</b></button>
            }
          </aside>
        }
        <app-sellers-page class="home-sellers-widget" [compact]="true" />
        @if(widgetEnabled('fortune') || widgetEnabled('categories')){<div [style.order]="fortuneWidgetOrder()">@if(site.usesSalesModel('categoryOffer')){<app-fortune-category-flow />}@else{<app-fortune-widget />}</div>}
        @if(widgetEnabled('feeds')){<div [style.order]="widgetOrder('feeds')"><app-feeds-widget [embedded]="true" /></div>}
        @if(widgetEnabled('blogs')){<div [style.order]="widgetOrder('blogs')"><app-blog-home-widget /></div>}
      </div>
    } @else if (site.config().businessMode === 'restaurant') {
      <app-restaurant-menu-home />
    } @else if (site.config().brandKey === 'hobyle' || (site.config().capabilities.commerce && !site.config().capabilities.services && !site.experience('fortune'))) {
      <app-hobyle-home />
    } @else if (site.config().businessMode === 'appointmentMarketplace') {
      <app-appointment-marketplace-home />
    } @else if (site.config().brandKey === 'ceondent' || site.config().brandKey === 'ucyoldis' || site.config().brandKey === 'umutdemironline' || site.config().brandKey === 'fmoshair' || site.config().brandKey === 'utkusahincoiffeur' || site.config().businessMode === 'serviceMarketplace') {
      <app-service-brand-home />
    } @else {
      <section class="hero">
        <p class="eyebrow">Yeni nesil coklu marka frontend</p>
        <h1>{{ site.config().name }} icin Angular vitrini hazir.</h1>
        <p class="lead">
          Backend linklerine dokunmadan; fal, falci, urun ve canli yayin akisini
          tek sayfa deneyimiyle yeniden kurmak icin temiz bir temel.
        </p>
        <nav class="actions">
          <a [routerLink]="i18n.routePath('fortune')">Fal Widgeti</a>
          <a [routerLink]="i18n.routePath('sellers')">Falcilar</a>
          <a [routerLink]="i18n.routePath('blog')">Blog</a>
        </nav>
      </section>

      <section class="grid">
        <article>
          <span>01</span>
          <h2>Config tabanli marka</h2>
          <p>Domain degisince tema, API base URL ve socket ayarlari configten gelir.</p>
        </article>
        <article>
          <span>02</span>
          <h2>SEO uyumlu rotalar</h2>
          <p>Web tarafinda /falci/slug ve /urun/slug gibi linkler Angular Router ile calisir.</p>
        </article>
        <article>
          <span>03</span>
          <h2>Backend ayni kalir</h2>
          <p>Servis katmani mevcut /get ve /api linklerini tek merkezden kullanir.</p>
        </article>
      </section>

      <app-blog-home-widget />
    }
  `,
  styles: [`
    :host { display:block; inline-size:100%; max-inline-size:100%; min-inline-size:0; overflow-x:clip; }
    :host-context(html[data-design='aymudo']) { overflow-x:visible; }
    .falderyasi-home-stack {
      display: grid;
      gap: clamp(34px, 5vw, 72px);
      margin: 0 auto;
      max-width: 1180px;
    }

    .falderyasi-home-stack > * {
      min-width: 0;
    }

    .home-sellers-heading{display:grid;gap:8px;margin-bottom:-28px;max-width:760px}.home-sellers-heading .eyebrow{color:var(--accent);font-size:.75rem;font-weight:950;letter-spacing:.16em;margin:0;text-transform:uppercase}.home-sellers-heading h1{color:var(--ink);font-family:Georgia,serif;font-size:clamp(2.4rem,5vw,4.8rem);letter-spacing:-.06em;line-height:.95;margin:0}.home-sellers-heading p:last-child{color:var(--muted);line-height:1.6;margin:0}
    .email-credit-banner{align-items:center;background:color-mix(in srgb,var(--accent) 12%,var(--surface));border:1px solid var(--accent);border-radius:22px;display:flex;gap:20px;justify-content:space-between;padding:20px 24px}.email-credit-banner h2{font-family:var(--font-display);font-size:clamp(1.4rem,3vw,2rem);margin:5px 0}.email-credit-banner p{color:var(--muted);margin:0}.email-credit-banner .eyebrow{color:var(--accent);font-size:.7rem;font-weight:950;letter-spacing:.14em}.email-credit-banner a,.email-credit-banner button{background:var(--accent);border:0;border-radius:999px;color:var(--accent-contrast);font:inherit;font-weight:900;padding:12px 17px;text-decoration:none;white-space:nowrap}.email-credit-banner button{cursor:pointer}.email-credit-banner a b,.email-credit-banner button b{margin-left:8px}@media(max-width:650px){.email-credit-banner{align-items:stretch;display:grid;padding:18px}.email-credit-banner a,.email-credit-banner button{text-align:center}}

    @media (max-width: 760px) {
      .falderyasi-home-stack {
        gap: 32px;
      }
    }
  `]
})
export class HomePage {
  protected readonly site = inject(SiteConfigService);
  protected readonly auth = inject(AuthService);
  protected readonly i18n = inject(I18nService);
  private readonly seo = inject(SeoService);
  private readonly pageData = inject(PageDataService);
  private readonly route = inject(ActivatedRoute);
  protected readonly homeCopy = computed(() => ({
    tr: { rewardLabel:'E-posta doğrulama ödülü', verifiedEyebrow:'100 KREDİ HEDİYESİ', verifyTitle:'E-posta adresini doğrula', verifyLead:'Hesabını doğrula, 100 kredi hesabına otomatik olarak eklensin.', verifyAction:'E-postayı doğrula', registerEyebrow:'KAYIT ÖDÜLÜ', registerTitle:'100 kredi hediye', registerLead:'Kayıt ol, e-posta adresini doğrula; 100 kredi hesabına otomatik olarak eklensin.', registerAction:'Kayıt ol' },
    en: { rewardLabel:'Email verification reward', verifiedEyebrow:'100 BONUS CREDITS', verifyTitle:'Verify your email address', verifyLead:'Verify your account and 100 credits will be added automatically.', verifyAction:'Verify email', registerEyebrow:'SIGN-UP REWARD', registerTitle:'Get 100 bonus credits', registerLead:'Create an account and verify your email to receive 100 credits automatically.', registerAction:'Create account' },
    de: { rewardLabel:'Belohnung für E-Mail-Bestätigung', verifiedEyebrow:'100 BONUS-GUTHABEN', verifyTitle:'E-Mail-Adresse bestätigen', verifyLead:'Bestätige dein Konto und erhalte automatisch 100 Guthaben.', verifyAction:'E-Mail bestätigen', registerEyebrow:'REGISTRIERUNGSBONUS', registerTitle:'100 Guthaben geschenkt', registerLead:'Registriere dich und bestätige deine E-Mail, um automatisch 100 Guthaben zu erhalten.', registerAction:'Registrieren' },
    es: { rewardLabel:'Recompensa por verificar el correo', verifiedEyebrow:'100 CRÉDITOS DE REGALO', verifyTitle:'Verifica tu correo electrónico', verifyLead:'Verifica tu cuenta y recibirás 100 créditos automáticamente.', verifyAction:'Verificar correo', registerEyebrow:'REGALO DE REGISTRO', registerTitle:'100 créditos de regalo', registerLead:'Regístrate y verifica tu correo para recibir 100 créditos automáticamente.', registerAction:'Registrarse' },
    fr: { rewardLabel:'Récompense de vérification de l’e-mail', verifiedEyebrow:'100 CRÉDITS OFFERTS', verifyTitle:'Vérifiez votre adresse e-mail', verifyLead:'Vérifiez votre compte et recevez automatiquement 100 crédits.', verifyAction:'Vérifier l’e-mail', registerEyebrow:'BONUS D’INSCRIPTION', registerTitle:'100 crédits offerts', registerLead:'Inscrivez-vous et vérifiez votre e-mail pour recevoir automatiquement 100 crédits.', registerAction:'S’inscrire' }
  })[this.i18n.lang()]);
  private readonly landingData = computed<any>(() => { this.pageData.data(); const response=this.pageData.get<any>('aymudoLanding')??{}; return response?.data??response??{}; });
  private readonly landingSeo = computed<{title?:string;description?:string;shareImage?:string}>(()=>this.landingData()?.landing?.seo??{});
  protected widgetEnabled(type:string):boolean{
    const widgets=this.site.config().homeWidgets;
    if(!widgets?.length)return true;
    if(this.site.usesSalesModel('categoryOffer') && (type==='fortune'||type==='categories')){
      const widget=widgets.find(item=>item.type==='fortune'||item.type==='categories');
      return !widget || widget.enabled!==false;
    }
    const widget=widgets.find(item=>item.type===type);
    return !!widget&&widget.enabled!==false
  }
  protected widgetOrder(type:string):number{const widgets=this.site.config().homeWidgets;if(!widgets?.length)return type==='fortune'?1:type==='feeds'?2:3;const index=widgets.findIndex(item=>item.type===type);return index<0?99:index}
  protected fortuneWidgetOrder():number{return Math.min(this.widgetOrder('fortune'),this.widgetOrder('categories'))}

  protected openRegister(): void {
    this.auth.requestLogin('register');
  }

  constructor() {
    effect(() => {
      const config = this.site.config();
      const isFortuneExperience = this.site.experience('fortune');
      const landingSeo = this.landingSeo();
      const isLandingPreview = !!this.route.snapshot.queryParamMap.get('landingPreview');
      this.seo.setPage({
        title: isFortuneExperience ? this.i18n.t('homeSeoTitle') : (config.brandKey === 'aymudo' && landingSeo.title ? landingSeo.title : this.site.text('seoHomeTitle', config.name)),
        description: isFortuneExperience
          ? this.i18n.t('homeSeoDescription')
          : (config.brandKey === 'aymudo' && landingSeo.description ? landingSeo.description : this.site.text('seoHomeDescription', config.branding.tagline)),
        image: config.brandKey === 'aymudo' ? landingSeo.shareImage : undefined,
        robots: isLandingPreview ? 'noindex,nofollow,noarchive' : undefined,
        path: '/',
        modifiedAt: this.landingData()?.publishedAt || config.lastUpdatedAt,
        schema: config.brandKey === 'aymudo' ? [
          {
            '@type': 'Organization',
            '@id': `${config.apiBaseUrl.replace(/\/+$/, '')}/#organization`,
            name: config.name,
            url: `${config.apiBaseUrl.replace(/\/+$/, '')}/`,
            description: landingSeo.description || this.site.text('seoHomeDescription', config.branding.tagline),
            logo: config.branding.logoLightUrl || config.branding.logoDarkUrl || undefined
          },
          {
            '@type': 'SoftwareApplication',
            '@id': `${config.apiBaseUrl.replace(/\/+$/, '')}/#software`,
            name: config.name,
            url: `${config.apiBaseUrl.replace(/\/+$/, '')}/`,
            applicationCategory: 'BusinessApplication',
            operatingSystem: 'Web, Android, iOS',
            description: landingSeo.description || this.site.text('seoHomeDescription', config.branding.tagline),
            provider: { '@id': `${config.apiBaseUrl.replace(/\/+$/, '')}/#organization` }
          }
        ] : config.capabilities.services ? {
          '@type': ['ceondent','ucyoldis'].includes(config.brandKey) ? 'Dentist' : 'LocalBusiness',
          '@id': `https://${config.domain}/#clinic`,
          name: config.name,
          url: `https://${config.domain}/`,
          description: this.site.text('seoHomeDescription', config.branding.tagline),
          telephone: config.seo?.telephone || undefined,
          priceRange: config.seo?.priceRange || undefined,
          image: config.seo?.image || config.branding.logoLightUrl || config.branding.logoDarkUrl || undefined,
          areaServed: { '@type': 'City', name: 'İzmir' },
          availableLanguage: config.supportedLocales?.map(locale => locale.lang) ?? config.supportedLangs
        } : undefined
      });
    });
  }
}
